<template>
  <v-container class="px-0 pt-0">
    <div class="h-full">
      <!-- 追加ボタン -->
      <div class="flex justify-center mb-4 p-4">
        <v-btn
          color="primary"
          elevation="0"
          class="rounded-full px-6"
          @click="openMedicationDialog(DISPLAY_MODE.REGISTER, '服薬情報登録')"
        >
          <v-icon left size="20">mdi-pill</v-icon>
          追加
        </v-btn>
      </div>

      <!-- 服薬情報リスト -->
      <v-container fluid class="overflow-y-auto px-4 pb-4">
        <v-row>
          <v-col
            v-for="medication in medications"
            :key="medication.medicationId"
            cols="12"
            class="d-flex justify-center"
          >
            <Medication
              :displayMode="DISPLAY_MODE.DETAIL"
              :medication="medication"
              :patientUid="patientUid"
              :key="medicationListUpdateKey"
            />
          </v-col>
        </v-row>
      </v-container>

      <!-- 服薬情報ダイアログ -->
      <v-dialog
        v-model="medicationDialog.show"
        :max-width="dialogMaxWidth"
        persistent
        no-click-animation
      >
        <Dialog @close="closeMedicationDialog">
          <!-- タイトル -->
          <template #title>
            {{ medicationDialog.title }}
          </template>

          <!-- コンテンツ -->
          <template #contents>
            <Medication
              :key="medicationDialog.updateKey"
              :displayMode="medicationDialog.displayMode"
              :medication="medicationDialog.medication"
              :patientUid="patientUid"
              @close="closeMedicationDialog"
            ></Medication>
          </template>
        </Dialog>
      </v-dialog>
    </div>
  </v-container>
</template>

<script>
import Medication from "@/components/dialogs/Medication";
import Dialog from "@/components/templates/Dialog";
import { DISPLAY_MODE } from "@/const/const";

export default {
  name: "MedicationList",
  components: {
    Medication,
    Dialog,
  },
  data() {
    return {
      DISPLAY_MODE,
      medications: [],
      patientUid: null,
      // 服薬情報ダイアログ
      medicationDialog: {
        show: false,
        displayMode: null,
        medication: null,
        title: "",
        updateKey: 1,
      },
      // 服薬情報リスト更新キー
      medicationListUpdateKey: 1,
    };
  },
  computed: {
    patient() {
      return this.$store.state.user.selfUser;
    },
    dialogMaxWidth() {
      // 画面の幅によって最大幅を変更
      if (window.innerWidth >= 1024) {
        return "650px";
      } else {
        return "90vw";
      }
    },
  },
  methods: {
    openMedicationDialog(displayMode, title, medication = undefined, patientUid = this.patientUid) {
      this.medicationDialog = {
        show: true,
        displayMode,
        title,
        medication,
        patientUid,
        updateKey: this.medicationDialog.updateKey,
      };
    },
    // ダイアログを閉じる
    closeMedicationDialog() {
      this.medicationDialog.updateKey++;
      this.medicationDialog.show = false;
    },
  },
  watch: {
    patient(newPatient) {
      if (newPatient && newPatient.uid) {
        this.patientUid = newPatient.uid;
      }
      if (newPatient && newPatient.medications) {
        this.medications = [...newPatient.medications];
      } else {
        this.medications = [];
      }
      this.medicationListUpdateKey++;
    },
  },
  mounted() {
    if (this.patient && this.patient.uid) {
      this.patientUid = this.patient.uid;
    }
    if (this.patient && this.patient.medications) {
      this.medications = [...this.patient.medications];
    } else {
      this.medications = [];
    }
  },
};
</script>
